import { createRouter, createWebHistory } from "vue-router";
import Home from "./pages/Home.vue";
import Teacher from "./pages/Teacher.vue";
import Parent from "./pages/Parent.vue";

const router = new createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", name: "home", component: Home },
    { path: "/teacher", name: "teacher", component: Teacher },
    { path: "/parent", name: "parent", component: Parent },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

export default router;
